// extracted by mini-css-extract-plugin
module.exports = {"cardview":"Card_cardview__3Gd8v","title":"Card_title__T5qx6","number":"Card_number__1vr4L"};